import { useEffect, useState } from 'react'

import { GetUserZone, SubmitResponse } from './../../../utilities/BL/Zones'


const Quiz = ({ questionId, options }) => {
    const [selectedOptionId, setSelectedOptionId] = useState(null)
    const [correctOptionId, setCorrectOptionId] = useState(null)
    const [selectedOptionText, setSelectedOptionText] = useState(null)


    // Reiniciar todo al cambiar de pregunta
    useEffect(() => {
        setSelectedOptionId(null)
        setCorrectOptionId(null)
        setSelectedOptionText(null)
    }, [questionId])

    const handleOptionClick = async (option) => {
        if (selectedOptionId !== null) return // ya respondió

        setSelectedOptionId(option.id)
        setCorrectOptionId(options.find(opt => opt.isCorrect)?.id || null)
        setSelectedOptionText(option.text)

        if (option.isCorrect) {
            try {
                const response = await SubmitResponse(questionId)
                
                if (!response.success) {
                    console.warn('❌ Error al enviar respuesta:', response.message)
                }
            } catch (err) {
                console.error('❌ Error inesperado:', err)
            }
        }
    }

    const LoadPage = async () => {
        try {
            const response = await GetUserZone()
            
            if (response.success) {
                switch (response.data.id) {
                    case 9:
                        document.body.classList.add('Quiz__Background__Femenil--Blue')
                        break
                        
                    case 10:
                        document.body.classList.add('Quiz__Background__Femenil--Golden')
                        break

                    default:
                        document.body.classList.remove('Quiz__Background__Femenil--Blue')
                        document.body.classList.remove('Quiz__Background__Femenil--Golden')
                        break
                }
            }    
        } catch (error) {
            
        }
    }

    useEffect(() => {
        LoadPage()

        return () => {
            document.body.classList.remove('Quiz__Background__Femenil--Blue')
            document.body.classList.remove('Quiz__Background__Femenil--Golden')
        }
    },[])

    if (!options || options.length === 0) {
        return <p className="Quiz__Title">Cargando opciones...</p>
    }
    

    return (
        <div className="Quiz">
            {/* Mostrar opciones SOLO si aún no ha respondido */}
            {selectedOptionId === null && (
                <>
                    <p className="Quiz__Title">Selecciona una opción</p>
                    <div className="Quiz__Options">
                        {options.map((option, index) => (
                            <button
                                key={index} // Usar index si los id no son únicos
                                className="Quiz__Options__Buttons Btn__Adsl--RedOutline"
                                onClick={() => handleOptionClick(option)}
                            >
                                {option.text}
                            </button>
                        ))}
                    </div>
                </>
            )}

            {/* Mostrar respuesta seleccionada una vez respondido */}
            {selectedOptionId !== null && (
                <div>
                    <p className="Quiz__Title">Respuesta elegida:</p>
                    <p className="Quiz__Title">{selectedOptionText}</p>
                </div>
            )}
        </div>
    )
}

export { Quiz };